module.exports = __webpack_public_path__ + "media/images/linkedin-eff041c7a33c37d26df549110f43f431.png";